import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const SendChat = createAsyncThunk("dummyData/SendChat", async ({message, requestId, senderId,timestamp,}) => {
    let response = await axios.post(`${BASE_URL}/chat/send`,  {
        message,
        requestId, 
        senderId,
        timestamp
        
    });
    return response;
});



const SendMsg = createSlice({
    name: "SendMsg",
    initialState: {
        loading: false,
        SendMsg: [],
        error: ""
    },
    extraReducers: {
        [SendChat.fulfilled]: (state, action) => {
            state.SendMsg = action.payload;
            state.loading = false;
        },
        [SendChat.pending]: (state) => {
            state.loading = true;
        },
        [SendChat.rejected]: (state, action) => {
            state.error = action.error.message;
        },
    }
});
export default SendMsg.reducer;